









































































import {
  SfButton,
} from '~/components';

import SkeletonLoader from '~/components/SkeletonLoader/index.vue';

import {
  defineComponent,
  onMounted,
  ref,
  useFetch,
  computed,
} from '@nuxtjs/composition-api';

import { usePageStore } from '~/stores/page';
import { useCategory } from '~/composables';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { sendEcommerce } from '~/utilities/helpers';
import { useTraverseCategory } from "~/modules/catalog/category/helpers/useTraverseCategory";
import CategoryBreadcrumbs from '~/modules/catalog/category/components/breadcrumbs/CategoryBreadcrumbs.vue';
import SfLink from "~/components/atoms/SfLink/SfLink.vue";

export default defineComponent({
  name: 'CategoryPage',
  components: {
    SfLink,
    SfButton,
    SkeletonLoader,
    CategoryBreadcrumbs,
  },
  transition: 'fade',
  setup() {
    const { routeData } = usePageStore();
    const { loadCategoryMeta } = useCategory();
    const { activeCategory } = useTraverseCategory();

    const categoryMeta = ref(null);
    const categoryUid = routeData.uid;
    const activeCategoryName = computed(() => activeCategory.value?.name ?? '');

    useFetch(async () => {
      const [ categoryMetaData ] = await Promise.all([
        loadCategoryMeta({ category_uid: categoryUid }),
      ]);

      categoryMeta.value = categoryMetaData;
    });

    onMounted(async () => {
      sendEcommerceCategory();
    });

    // Ecommerce and Pixels
    const sendEcommerceCategory = () => {
      sendEcommerce('view_item', 'category', []);
    };

    return {
      categoryMeta,
      activeCategoryName,
    };
  },
  head() {
    return getMetaInfo(this.categoryMeta);
  }
});
